module.exports = __webpack_public_path__ + "static/media/4.2f4ce178.png";